export enum RebateTypes {
  Penalty = 1,
  Arrears = 2,
  Date = 3,
  Gender = 4,
}
